/* @flow */
import * as React from 'react';

import View from 'components/View';
import Row from 'components/Row';
import Button from 'components/Button';
import Heading from 'components/Heading';
import Text from 'components/Text';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import LinkConstants from 'constants/LinkConstants';

export const LearnMorePage = () => (
  <View>
    <Row>
      <Heading>What is a restricted carrier?</Heading>
      <Text lineHeight="large" size="small" color="thunder">
        Some mobile networks, including Rogers and Bell, charge extra for text messages. As a
        result, Remind cannot offer text message delivery to these mobile networks for free.
      </Text>
    </Row>
    <Row size="small">
      <Heading>What are my options?</Heading>
    </Row>
    <Row size="small">
      <Heading levelStyle="6">
        <Text size="xxxsmall" color="midnight">
          Get everyone on the free app
        </Text>
      </Heading>
      <Text lineHeight="large" size="small" color="thunder">
        Recipients on these unsupported mobile networks can download the Remind app to receive your
        messages for free.
      </Text>
    </Row>
    <Row size="xlarge">
      <Heading levelStyle="6">
        <MediaObject center gutter="xxsmall">
          <Text size="xxxsmall" color="midnight">
            Upgrade to a school or district plan
          </Text>
          <Image src={require('assets/images/remind-pro-badge.svg')} />
        </MediaObject>
      </Heading>
      <Text lineHeight="large" size="small" color="thunder">
        Remind Plans are available for schools & districts and include text messaging to students
        and parents on unsupported mobile networks.
      </Text>
    </Row>
    <Row>
      <Button
        eventElementName="IndividualPlansLearnMore-viewPlans"
        href={LinkConstants.MOBILE_PLANS}
        full>
        View Remind Plans
      </Button>
    </Row>
  </View>
);

export const IOSPurchaseTerms = () => (
  <View>
    <Text lineHeight="large" size="small" color="thunder">
      Payment will be charged to iTunes Account at confirmation of purchase. Subscription
      automatically renews unless auto-renew is turned off at least 24 hours before the end of the
      current period. Subscriptions may be managed by the user and auto-renewal may be turned off by
      going to the user&apos;s App Store Account Settings after purchase.
    </Text>
  </View>
);

export const AndroidPurchaseTerms = () => (
  <View>
    <Text lineHeight="large" size="small" color="thunder">
      Payment will be charged to your Play Store account at confirmation of purchase. Subscription
      automatically renews unless auto-renew is turned off at least 24 hours before the end of the
      current period. Subscriptions may be managed by the user and auto-renewal may be turned off by
      going to the user&apos;s Play Store Account Settings after purchase.
    </Text>
  </View>
);
